/* Savaaya Atelier — product page */
(() => {
  const debounce = (fn, wait = 80) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); }; };

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.items = Array.from(this.querySelectorAll('.gallery__item'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.dots = Array.from(this.querySelectorAll('.gallery__dots span'));
      this.counter = this.querySelector('[data-current]');
      if (!this.track) return;

      this.track.addEventListener('scroll', debounce(() => this.syncFromScroll()), { passive: true });
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.thumb, 10))));
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      prev && prev.addEventListener('click', () => this.goTo(Math.max(0, this.index - 1)));
      next && next.addEventListener('click', () => this.goTo(Math.min(this.items.length - 1, this.index + 1)));
      this.index = 0;

      const root = this.closest('[data-product-root]');
      root && root.addEventListener('variant:change', (e) => {
        const v = e.detail.variant;
        if (!v || !v.media_id) return;
        const i = this.items.findIndex((it) => it.dataset.mediaId === String(v.media_id));
        if (i > -1) this.goTo(i, true);
      });

      const active = this.items.findIndex((it) => it.classList.contains('is-active'));
      if (active > 0) requestAnimationFrame(() => this.goTo(active, false, 'auto'));
    }
    isHorizontal() { return this.track.scrollWidth > this.track.clientWidth + 2; }
    goTo(i, fromVariant, behavior = 'smooth') {
      const item = this.items[i];
      if (!item) return;
      if (this.isHorizontal()) {
        this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior });
      } else if (fromVariant) {
        const top = item.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) - 16;
        window.scrollTo({ top, behavior });
      }
      this.setActive(i);
    }
    syncFromScroll() {
      if (!this.isHorizontal()) return;
      const w = this.items[0].getBoundingClientRect().width || 1;
      this.setActive(Math.round(this.track.scrollLeft / w));
    }
    setActive(i) {
      this.index = i;
      this.items.forEach((it, j) => it.classList.toggle('is-active', i === j));
      this.thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
      this.dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      if (this.counter) this.counter.textContent = i + 1;
      const thumb = this.thumbs[i];
      if (thumb && thumb.parentElement.scrollHeight > thumb.parentElement.clientHeight) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }
  customElements.define('media-gallery', MediaGallery);

  class ProductLightbox extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[data-product-root]');
      if (!root) return;
      root.addEventListener('click', (e) => {
        const z = e.target.closest('[data-zoom]');
        if (z) this.open(parseInt(z.dataset.zoom, 10));
      });
      this.addEventListener('click', (e) => { if (e.target.closest('[data-close]') || e.target.tagName === 'IMG') this.close(); });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
    }
    open(index) {
      this.querySelectorAll('img[data-src]').forEach((img) => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      const target = this.querySelector(`.lightbox__item[data-index="${index}"]`);
      requestAnimationFrame(() => { if (target) target.scrollIntoView({ block: 'start' }); });
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
    }
  }
  customElements.define('product-lightbox', ProductLightbox);

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[data-product-root]');
      const buy = root && root.querySelector('[data-main-buy]');
      if (!buy || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('has-sticky-atc', show);
      });
      io.observe(buy);
      this.querySelector('[data-sticky-atc]').addEventListener('click', () => {
        const picker = root.querySelector('variant-picker');
        const btn = buy.querySelector('[name="add"]');
        if (!picker && btn && !btn.disabled) { btn.click(); return; }
        const target = picker || buy;
        const top = target.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) - 24;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    }
  }
  customElements.define('sticky-atc', StickyAtc);

  /* Recently viewed — store handle for the "recently viewed" section */
  const root = document.querySelector('[data-product-root]');
  const handle = window.location.pathname.split('/products/')[1];
  if (root && handle) {
    try {
      const key = 'savaaya-recent';
      const list = JSON.parse(localStorage.getItem(key) || '[]').filter((h) => h !== handle.split('?')[0]);
      list.unshift(handle.split('?')[0]);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* storage blocked */ }
  }
})();
